export class I18nUtils {
    public static SUPPORTED_LANGUAGES = ["fr", "en"];
    public static DEFAULT_LANGUAGE = "fr";
}
